import { Company } from '../../models/dbmodels';
import { createReducer, on } from '@ngrx/store';
import { loadCompaniesFailure, loadCompaniesSuccess } from './company.actions';

export interface CompaniesState {
  companies: Company[];
}

export const initialCompaniesState: CompaniesState = {
  companies: [],
};

export const companiesFeatureKey = 'companiesState';

export const companiesReducer = createReducer(
  initialCompaniesState,
  on(loadCompaniesSuccess, (state, { companies }): CompaniesState => {
    return { ...state, companies };
  }),
  on(loadCompaniesFailure, (state, { error }): CompaniesState => {
    console.error(error);
    return state;
  }),
);
